namespace Ir.Components.Email.SendEmailNowButton {
    interface IViewModel {
        buttonOptions: DevExpress.ui.dxButton.Properties
    }
    interface IParams {
        activeTab: KnockoutObservable<WorkbookTab>;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.buttonOptions = {
            hint: 'Email',
            template: `<i class="ms">mail</i> Email`,
            onClick(e) {
                Ir.Components.Email.SendEmailNow.show(params.activeTab);
            }
        };
    }
}